var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap-module",class:_vm.dviceStatus},_vm._l((_vm.groups),function(item){return _c('CardGroup',{attrs:{"group":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }